// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__HEXIa","footer":"ReportModalFilter_footer__26M_D"};